import { render, staticRenderFns } from "./landslide.vue?vue&type=template&id=2bc9badb&scoped=true&"
import script from "./landslide.vue?vue&type=script&lang=js&"
export * from "./landslide.vue?vue&type=script&lang=js&"
import style0 from "./landslide.vue?vue&type=style&index=0&id=2bc9badb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc9badb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2bc9badb', component.options)
    } else {
      api.reload('2bc9badb', component.options)
    }
    module.hot.accept("./landslide.vue?vue&type=template&id=2bc9badb&scoped=true&", function () {
      api.rerender('2bc9badb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/monitor/swcb/landslide.vue"
export default component.exports